(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["viteba-black-friday"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('viteba-bf-vip26')) {
    customElements.define('viteba-bf-vip26', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.controller = new AbortController();
        const fitViewport=() => this.style.setProperty('--vbfvip-viewport',document.documentElement.clientWidth+'px');
        fitViewport();
        window.addEventListener('resize',fitViewport,{passive:true,signal:this.controller.signal});
        this.config = JSON.parse(this.querySelector('[data-vbfvip-config]').textContent);
        this.copy = this.config.copy;
        this.root = this.config.root.endsWith('/') ? this.config.root : this.config.root + '/';
        this.queue = Promise.resolve();
        this.rails = [];
        this.setupFloatingCart();
        this.setupNavigation();
        this.setupImageLoading();
        this.updateCartBar(Number(this.querySelector('[data-vbfvip-cart-count]')?.textContent || 0));
        this.querySelectorAll('[data-vbfvip-rail]').forEach(rail => this.setupRail(rail));
        this.addEventListener('click', event => this.handleClick(event), {signal:this.controller.signal});
        this.addEventListener('submit', event => this.handleSubmit(event), {signal:this.controller.signal});
        document.addEventListener('click', event => {
          const link=event.target.closest('a[href]');
          if (!link) return;
          const url=new URL(link.href,location.href);
          if (url.origin===location.origin && url.pathname.replace(/\/$/,'') === (this.root+'cart').replace(/\/$/,'')) {event.preventDefault();event.stopImmediatePropagation();this.openCart();}
        },{capture:true,signal:this.controller.signal});
        document.addEventListener('shopify:block:select', event => {
          const card = [...this.querySelectorAll('[data-vbfvip-card]:not([data-vbfvip-clone])')].find(node => node.dataset.blockId === event.detail.blockId);
          if (card) card.scrollIntoView({block:'center',inline:'center',behavior:'auto'});
        }, {signal:this.controller.signal});
        if (!this.config.designMode && this.config.code) this.enqueue(async () => {const cart=await this.applyCode();await this.syncThemeCart(cart);}).catch(() => this.setCodeState('error',this.copy.codeFailed,this.copy.checkCart));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.cartVisibilityObserver?.disconnect();
        clearTimeout(this.cartVisibilityTimer);
        cancelAnimationFrame(this.navFrame);
        clearTimeout(this.imageTimeout);
        this.rails?.forEach(rail => {rail._observer?.disconnect();cancelAnimationFrame(rail._frame);clearTimeout(rail._settle);});
        this.ready = false;
      }
      setupFloatingCart() {
        const bar = this.querySelector('[data-vbfvip-cart-bar]');
        const drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (!drawer) return;
        const update = () => {
          const rect = drawer.getBoundingClientRect();
          const style = getComputedStyle(drawer);
          const visible = !drawer.hidden && drawer.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0 && rect.width > 0 && rect.height > 0 && rect.right > 1 && rect.left < innerWidth - 1 && rect.bottom > 1 && rect.top < innerHeight - 1;
          bar.hidden = visible;
        };
        const schedule = () => {clearTimeout(this.cartVisibilityTimer);this.cartVisibilityTimer = setTimeout(update,400);};
        drawer.addEventListener('theme:drawer:open',() => {bar.hidden = true;},{signal:this.controller.signal});
        drawer.addEventListener('theme:drawer:close',schedule,{signal:this.controller.signal});
        drawer.addEventListener('transitionend',update,{signal:this.controller.signal});
        this.cartVisibilityObserver = new MutationObserver(schedule);
        this.cartVisibilityObserver.observe(drawer,{attributes:true,attributeFilter:['class','style','aria-hidden','open','hidden','data-state']});
        update();
      }
      setupNavigation() {
        this.navLinks = [...this.querySelectorAll('[data-vbfvip-jump]')];
        this.navShelves = [...this.querySelectorAll('[data-vbfvip-shelf]')];
        this.navLinks.forEach(link => {link.hidden = !this.navShelves.some(shelf => shelf.dataset.vbfvipShelf === link.dataset.vbfvipJump);});
        const update = () => {
          this.navFrame = null;
          const bar = this.querySelector('.vbfvip__category-bar');
          const top = (parseFloat(getComputedStyle(this).getPropertyValue('--vbfvip-nav-top')) || 0) + bar.offsetHeight + 32;
          let active = this.navShelves[0];
          for (const shelf of this.navShelves) {if (shelf.getBoundingClientRect().top <= top) active = shelf;}
          this.navLinks.forEach(link => {
            const selected = active?.dataset.vbfvipShelf === link.dataset.vbfvipJump;
            if (selected) link.setAttribute('aria-current','location');
            else link.removeAttribute('aria-current');
          });
        };
        const schedule = () => {if (!this.navFrame) this.navFrame = requestAnimationFrame(update);};
        window.addEventListener('scroll',schedule,{passive:true,signal:this.controller.signal});
        window.addEventListener('resize',schedule,{passive:true,signal:this.controller.signal});
        update();
      }
      setupImageLoading() {
        const settle = image => {
          if (!image.matches?.('.vbfvip__image')) return;
          image.closest('.vbfvip__photo')?.classList.remove('is-loading');
        };
        this.addEventListener('load',event => settle(event.target),{capture:true,signal:this.controller.signal});
        this.addEventListener('error',event => settle(event.target),{capture:true,signal:this.controller.signal});
        this.querySelectorAll('img.vbfvip__image').forEach(image => {
          if (!image.complete) image.closest('.vbfvip__photo')?.classList.add('is-loading');
        });
        this.imageTimeout = setTimeout(() => this.querySelectorAll('.vbfvip__photo.is-loading').forEach(photo => photo.classList.remove('is-loading')),12000);
      }
      updateCartBar(count) {
        this.querySelector('[data-vbfvip-cart-bar]')?.classList.toggle('has-items',count > 0);
      }
      reduced() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
      enqueue(job) { const operation = this.queue.then(job); this.queue = operation.catch(() => {}); return operation; }
      async request(endpoint, body) {
        const response = await fetch(this.root + endpoint, {method:body ? 'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:body ? JSON.stringify(body):undefined});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.copy.error);
        return data;
      }
      setCodeState(state,title,detail) {
        this.querySelector('.vbfvip__coupon').dataset.state = state;
        this.querySelector('[data-vbfvip-code-status]').textContent = title;
        this.querySelector('[data-vbfvip-code-detail]').textContent = detail;
      }
      async syncThemeCart(cart, open = false) {
        this.updateCartBar(cart.item_count);
        this.querySelectorAll('[data-vbfvip-cart-count]').forEach(node => node.textContent = cart.item_count);
        const drawer = document.querySelector('[data-drawer="drawer-cart"]');
        const items = drawer?.querySelector('[data-line-items]');
        const ready = new Promise(resolve => {
          if (!items || !cart.item_count) {resolve(true);return;}
          const observer = new MutationObserver(() => {observer.disconnect();clearTimeout(timer);resolve(true);});
          const timer = setTimeout(() => {observer.disconnect();resolve(false);},5000);
          observer.observe(items,{childList:true,subtree:true});
        });
        document.dispatchEvent(new CustomEvent('theme:cart:change',{detail:{cart},bubbles:true}));
        document.dispatchEvent(new CustomEvent('theme:cart:reload',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart,source:'viteba-bf-vip26'}}));
        const refreshed = await ready;
        if (!open) return;
        if (!drawer || (!refreshed && items && cart.item_count && drawer.querySelector('[data-cart-empty]:not(.cart--hidden)'))) throw new Error(this.copy.drawerError);
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open',{bubbles:false}));
      }
      openCart() {
        if (this.config.designMode || this.cartOpening) return;
        this.cartOpening = true;
        const cta = this.querySelector('.vbfvip__checkout-button');
        cta?.setAttribute('aria-busy','true');
        this.enqueue(async () => {const cart = await this.request('cart.js');await this.syncThemeCart(cart,true);}).catch(error => {
          const notice=this.querySelector('[data-vbfvip-notice]');notice.dataset.error='true';notice.textContent=error.message || this.copy.drawerError;
        }).finally(() => {this.cartOpening = false;cta?.removeAttribute('aria-busy');});
      }
      async applyCode() {
        if (!this.config.code) {this.setCodeState('pending',this.copy.codePending,this.copy.checkCart);return this.request('cart.js');}
        const cart = await this.request('cart/update.js',{discount:this.config.code});
        const names = [...(cart.discount_codes || []).filter(discount => discount.applicable !== false),...(cart.cart_level_discount_applications || []),...(cart.items || []).flatMap(item => [...(item.discounts || []),...(item.line_level_discount_allocations || []).map(allocation => allocation.discount_application)])];
        const accepted = names.some(discount => String(discount?.title || discount?.code || '').toUpperCase() === this.config.code.toUpperCase());
        if (accepted) this.setCodeState('applied',this.copy.codeApplied,this.copy.autoExplanation);
        else if (!cart.item_count) this.setCodeState('ready',this.copy.codeReady,this.copy.autoExplanation);
        else this.setCodeState('error',this.copy.codeInvalid,this.copy.checkCart);
        return cart;
      }
      setupRail(rail) {
        rail._index = 0;
        rail._pointer = false;
        this.rails.push(rail);
        const settle = () => {
          clearTimeout(rail._settle);
          rail._settle = setTimeout(() => {
            if (rail._pointer || rail._animating || rail.dataset.vbfvipLoop === 'false') return;
            const step = this.step(rail);
            const group = step * rail._count;
            let next = rail.scrollLeft;
            if (next < group) next += group;
            else if (next >= group * 2) next -= group;
            if (Math.abs(next-rail.scrollLeft) > 1) {
              rail.style.scrollSnapType = 'none';
              rail.scrollLeft = next;
              requestAnimationFrame(() => {if (!rail._animating) rail.style.scrollSnapType = '';});
            }
            rail._index = ((Math.round(rail.scrollLeft / step) % rail._count) + rail._count) % rail._count;
            this.position(rail);
          },180);
        };
        const rebuild = () => {
          const width = rail.clientWidth;
          if (Math.abs(width-(rail._width || 0)) < 1) return;
          rail._width = width;
          this.stop(rail);
          clearTimeout(rail._settle);
          rail.querySelectorAll('[data-vbfvip-clone]').forEach(node => node.remove());
          const originals = [...rail.children];
          rail._count = originals.length;
          rail.dataset.vbfvipLoop = 'true';
          const step = this.step(rail);
          const allFit = step * rail._count - 16 <= width + 1;
          rail.closest('[data-vbfvip-shelf]').querySelectorAll('[data-vbfvip-step]').forEach(button => button.disabled = allFit);
          if (allFit) {
            rail.dataset.vbfvipLoop = 'false';
            rail.scrollLeft = 0;
          } else {
            for (const side of ['before','after']) {
              const fragment = document.createDocumentFragment();
              originals.forEach(card => {
                const clone = card.cloneNode(true);
                clone.dataset.vbfvipClone = 'true';
                clone.setAttribute('aria-hidden','true');
                clone.removeAttribute('data-shopify-editor-block');
                clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
                clone.querySelectorAll('a,button,input').forEach(node => node.tabIndex = -1);
                fragment.append(clone);
              });
              if (side === 'before') rail.prepend(fragment); else rail.append(fragment);
            }
            rail.style.scrollSnapType = 'none';
            rail.scrollLeft = step * (rail._count + rail._index);
            requestAnimationFrame(() => {rail.style.scrollSnapType = '';});
          }
          this.position(rail);
        };
        rail.addEventListener('scroll',() => {
          if (rail.dataset.vbfvipLoop !== 'false') {
            rail._index = ((Math.round(rail.scrollLeft / this.step(rail)) % rail._count) + rail._count) % rail._count;
            this.position(rail);
          }
          settle();
        },{passive:true,signal:this.controller.signal});
        rail.addEventListener('pointerdown',() => {rail._pointer=true;clearTimeout(rail._settle);this.stop(rail);},{passive:true,signal:this.controller.signal});
        const release = () => {rail._pointer=false;settle();};
        window.addEventListener('pointerup',release,{passive:true,signal:this.controller.signal});
        window.addEventListener('pointercancel',release,{passive:true,signal:this.controller.signal});
        rail._observer = new ResizeObserver(rebuild);
        rail._observer.observe(rail);
        requestAnimationFrame(rebuild);
      }
      step(rail) { return rail.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 16); }
      position(rail) { rail.closest('[data-vbfvip-shelf]').querySelector('[data-vbfvip-position]').textContent = rail.dataset.vbfvipLoop === 'false' ? rail._count+' / '+rail._count : this.copy.swipe + ' · ' + (rail._index + 1) + ' / ' + rail._count; }
      stop(rail) {cancelAnimationFrame(rail._frame);rail._animating = false;rail.style.scrollSnapType = '';}
      move(rail,direction) {
        if (rail.dataset.vbfvipLoop === 'false') return;
        clearTimeout(rail._settle);
        const from = rail.scrollLeft;
        const target = (rail._animating ? rail._target : Math.round(from / this.step(rail)) * this.step(rail)) + direction * this.step(rail);
        this.stop(rail);
        rail._target = target;
        if (this.reduced()) {rail.scrollLeft = target;rail.dispatchEvent(new Event('scroll'));return;}
        rail._animating = true;
        rail.style.scrollSnapType = 'none';
        const start = performance.now();
        const animate = now => {
          const progress = Math.min(1,(now-start)/360);
          rail.scrollLeft = from + (target-from)*(1-Math.cos(Math.PI*progress))/2;
          if (progress < 1) rail._frame = requestAnimationFrame(animate);
          else {this.stop(rail);rail.dispatchEvent(new Event('scroll'));}
        };
        rail._frame = requestAnimationFrame(animate);
      }
      async toggle(button) {
        const shelf = button.closest('[data-vbfvip-shelf]');
        if (shelf.dataset.busy || button.getAttribute('aria-pressed') === 'true') return;
        shelf.dataset.busy = 'true';
        const rail = shelf.querySelector('[data-vbfvip-rail]');
        this.stop(rail);
        try {
          if (!this.reduced()) await rail.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(4px)'}],{duration:100,easing:'ease-in-out',fill:'forwards'}).finished;
          shelf.querySelectorAll('[data-vbfvip-toggle]').forEach(node => node.setAttribute('aria-pressed',String(node === button)));
          shelf.querySelectorAll('[data-vbfvip-format]').forEach(node => node.hidden = node.dataset.vbfvipFormat !== button.dataset.vbfvipToggle);
          rail.getAnimations().forEach(animation => animation.cancel());
          if (!this.reduced()) await rail.animate([{opacity:0,transform:'translateY(4px)'},{opacity:1,transform:'translateY(0)'}],{duration:180,easing:'ease-in-out'}).finished;
        } finally {rail.getAnimations().forEach(animation => animation.cancel());delete shelf.dataset.busy;}
      }
      handleClick(event) {
        if (event.target.closest('[data-vbfvip-open-cart]')) {this.openCart();return;}
        const jump = event.target.closest('[data-vbfvip-jump]');
        if (jump) {
          const target = this.querySelector('[data-vbfvip-shelf="'+jump.dataset.vbfvipJump+'"]');
          if (target) {event.preventDefault();target.scrollIntoView({block:'start',behavior:this.reduced()?'auto':'smooth'});}
        }
        const arrow = event.target.closest('[data-vbfvip-step]');
        if (arrow) this.move(arrow.closest('[data-vbfvip-shelf]').querySelector('[data-vbfvip-rail]'),Number(arrow.dataset.vbfvipStep));
        const toggle = event.target.closest('[data-vbfvip-toggle]');
        if (toggle) this.toggle(toggle).catch(() => {});
      }
      handleSubmit(event) {
        const form = event.target.closest('[data-vbfvip-form]');
        if (!form) return;
        event.preventDefault();
        if (this.config.designMode) return;
        const button = form.querySelector('button');
        if (button.disabled) return;
        button.disabled = true;
        button.textContent = this.copy.adding;
        const notice = this.querySelector('[data-vbfvip-notice]');
        let wasAdded = false;
        this.enqueue(async () => {
          await this.request('cart/add.js',{items:[{id:form.elements.id.value,quantity:1}]});
          wasAdded = true;
          let cart;
          try {cart = await this.applyCode();}
          catch {this.setCodeState('error',this.copy.codeFailed,this.copy.checkCart);cart = await this.request('cart.js');}
          await this.syncThemeCart(cart,true);
          notice.dataset.error = 'false';
          notice.textContent = this.copy.added;
          button.textContent = this.copy.added;
        }).catch(error => {notice.dataset.error=String(!wasAdded);notice.textContent=wasAdded ? this.copy.added+' '+this.copy.checkCart : error.message || this.copy.error;button.textContent=wasAdded ? this.copy.added : this.copy.add;}).finally(() => {button.disabled=false;setTimeout(() => {if(button.isConnected)button.textContent=this.copy.add;},1600);});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
